
























































































































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../lib/ajax';
import AbpBase from '../../../../../lib/abpbase';
import QuickTable from "../../../../../components/table/table.vue";
import ImportModal from "../../../../../components/tools/importModal.vue";
@Component({
	name:'productFacility',
	components: {
		QuickTable,
		ImportModal
	}
})
export default class ProductFacility extends AbpBase {
	initData:any = {
		showModal: false,
		formLoading: false,
		personData: [],
		organizations: [],			// 部门数据
		formData: {
			id: '',
			facilityType: '',
			facilityName: '',
			hasAllOriginalData: 'true',
			hasAllFullSet: 'true',
			isRunNormal: 'true',
			hasInfluenceToBody: 'false',
			protectiveMeasures: '',
			makeSureSafety: 'true',
			useDepId: '',
			useLeaderId: '',
			hasPlanAtYearBegin: 'true',
			overhauler: '',
			overhaulInfo: ''
		},
		validate: {
			facilityType: [
				{ required: true, message: '请填写设备类型', trigger: 'blur' }
			],
			facilityName: [
				{ required: true, message: '请填写设备名称', trigger: 'blur' }
			],
			useDepId: [
				{ required: true, type: 'number', message: '请选择使用部门', trigger: 'change' }
			],
			useLeaderId: [
				{ required: true, type: 'number', message: '请选择使用责任人', trigger: 'change' }
			]
		},
		columns: [
			{
				title: '序号',
				type: 'index',
				width: 60
			},
			{
				title: '设备类型',
				key: 'facilityType',
				width: 128
			},
			{
				title: '设备名称',
				key: 'facilityName',
				width: 148
			},
			{
				title: '原始技术资料、图纸、使用说明书是否齐全',
				key: 'hasAllOriginalDataDesc',
				width: 168
			},
			{
				title: '设备设施全套是否齐全',
				key: 'hasAllFullSetDesc',
				width: 106
			},
			{
				title: '能否正常使用',
				key: 'isRunNormalDesc',
				width: 110
			},
			{
				title: '对身体有无影响',
				key: 'hasInfluenceToBodyDesc',
				width: 125
			},
			{
				title: '采取的防护措施',
				key: 'protectiveMeasures',
				width: 160
			},
			{
				title: '防护设备是否能保证安全，是否检查',
				key: 'makeSureSafetyDesc',
				width: 168
			},
			{
				title: '使用部门',
				key: 'useDep',
				width: 128,
				render: (h:any, params:any) => {
					return h('span', params.row.useDep ? params.row.useDep.displayName : '');
				}
			},
			{
				title: '使用责任人',
				key: 'useLeader',
				width: 128,
				render: (h:any, params:any) => {
					return h('span', params.row.useLeader ? params.row.useLeader.name : '');
				}
			},
			{
				title: '年初有无检修计划（设备、设施、仪器、仪表和器材清单）',
				key: 'hasPlanAtYearBeginDesc',
				width: 180
			},
			{
				title: '检修人',
				key: 'overhauler',
				width: 96
			},
			{
				title: '检测检验检修情况和记录',
				key: 'overhaulInfo',
				width: 150
			},
			{
				title: '操作',
				key: 'action',
				width: 128,
				render: (h:any, params:any) => {
					return h('div', [
						h('Button', {
							props: {
								type: 'success',
								size: 'small'
							},
							on: {
								click: () => {
									for(let k in this.initData.formData) {
										this.initData.formData[k] = (typeof params.row[k] === 'boolean' ? params.row[k].toString() : params.row[k]);
									}
									this.initData.showModal = true;
								}
							}
						}, '编辑'),
						h('Button', {
							props: {
								type: 'error',
								size: 'small'
							},
							style: {
								marginLeft: '10px'
							},
							on: {
								click: () => {
									this.handleDelete(params.row.id);
								}
							}
						}, '删除')
					])
				}
			}
		]
	}
	// 初始化
    init() {
    	// 获取部门信息
    	this.$store.dispatch('project/GetbearerOrg').then(() => {
    		this.initData.organizations = this.$store.state.project.bearerOrgId;
    	})
    	// 获取所有人员信息
    	this.$store.dispatch('project/GetAllPersons').then(() => {
    		this.initData.personData = this.$store.state.project.allPersons;
    	})
    }
    // 新增记录
    async handleSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
          		let datas:any = this.initData.formData;
          		let params:any = {};
          		for(let k in this.initData.formData) {
					if(k !== 'id') {
						params[k] = datas[k];
					}
				}
            	this.initData.formLoading = true;
            	if(datas.id) {
            		params.id = datas.id;
            		await Ajax.put('/api/services/app/SafetyProduct/UpdateFacilityAsync', params).then((res:any)=>{
		                this.$Message.success('修改成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}else{
            		await Ajax.post('/api/services/app/SafetyProduct/CreateFacilityAsync', params).then((res:any)=>{
		                this.$Message.success('提交成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}
            }
        })
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		this.initData.showModal = false;
    		this.initData.formData.id = '';
    		(this as any).$refs.form.resetFields();
    	}
    }
    async handleDelete(id:any) {
    	this.$Modal.confirm({
            title: '操作确认',
            content: '是否确认删除此生产设施设备管理台账？',
            onOk: () => {
                Ajax.delete('/api/services/app/SafetyProduct/DeleteFacilityAsync', {params: {Id: id}}).then((res:any)=>{
	                this.$Message.success('删除成功!');
                	(this as any).$refs.table.GetData();
	            })
            }
        });
    }
    mounted() {
    	this.init();
    }
}
